export const CommandPaletteNames = {
  SEARCH_FIRM_OFFER: 'search-firm-offer',
} as const
